import $ from "jquery";

// Global flag to control opened modals
window.isModalOpen = false;

/**
 * Function to show a modal.
 * @param {string} modalId - ID of the modal to be shown.
 */
export function showModal(modalId, isManual = false) {
  if (window.isModalOpen) {
    console.log("There is a modal showing, we will not show the second one");
    return;
  }

  const modal = $(modalId);

  // Ensure the modal is not hidden for assistive technologies
  modal.attr("aria-hidden", "false");

  // Show the modal
  modal.modal("show");

  // Update the global flag
  window.isModalOpen = true;

  // Disable interaction with the background content using the 'inert' attribute
  disableBackground();

  // Reset flag and attributes when the modal is closed
  modal.on("hidden.bs.modal", () => {
    modal.attr("aria-hidden", "true");
    window.isModalOpen = false;

    // Re-enable interaction with the background content
    enableBackground();

    console.log(`Modal ${modalId} closed. Flag reset.`);
  });
}

/**
 * Function to check if there is any modal open.
 * @returns {boolean} - True if there is a modal open, false otherwise.
 */
export function isAnyModalOpen() {
  return window.isModalOpen;
}

/**
 * Function to disable interaction with background content when a modal is open.
 */
function disableBackground() {
  $("body > *").not(".modal, #CybotCookiebotDialog").attr("inert", true);
}

/**
 * Function to re-enable interaction with background content when a modal is closed.
 */
function enableBackground() {
  $("body > *").not(".modal").removeAttr("inert");
}

window.showManualModal = (modalId) => {
    showModal(`#${modalId}`, true); // Mark this modal as manual
  };